import api from './api';

export const email_subscribe = async (email) => {
  const res = await api.post(
    "/email/subscribe",
    { email },                     
    { requiresAuth: false } 
  );
  return res.data.message;
};

